import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { Loading, Message } from 'element-ui';
// create an axios instance
const service = axios.create({
    baseURL: window.api.apiurl, // url = base url + request url
    withCredentials: true, // 允许跨域携带凭证（如 cookies）
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 40000 // request timeout
})


let loading //定义loading变量

function startLoading() { //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}

function endLoading() { //使用Element loading-close 方法
    loading.close()
}

// request interceptor
service.interceptors.request.use(

    config => {
        startLoading()

        // do something before request is sent
        // config.headers.Authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiY3MxMjM0NTYiLCJVc2VySWQiOiIwOGQ4YzQyNS04NWY0LTQ2YjAtODYzYS1kZDhlOWExMzY5NzEiLCJuYmYiOjE2NTgxMzEwODksImV4cCI6MTY1ODczNTg4OX0.HtJzWkI488IdEGKEec1036-hOVVWGeP0_6N5Y57q_xk"

        if (store.state.token) {
            config.headers.Authorization = `Bearer ${store.state.token}`
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            // config.headers['X-Token'] = getToken()
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        endLoading()
        const res = response.data
        // if the custom code is not 20000, it is judged as an error.
        if (res.succeed == false) {
            Message.closeAll()
            Message({
                message: res.error || res.data || 'Error',
                type: 'error',
                duration: 2000
            })
            return res
            // return Promise.reject(res)
            // return Promise.reject(new Error(res.error || 'Error'))
        } else {
            return res
        }
    },
    error => {
        endLoading()

        console.log(error)

        // console.log('err' + error) // for debug
        // if (error.response.status) {
        //     switch (error.response.status) {
        //         case 400:
        //            Message.closeAll()
        //            Message.error(error.response.data)
        //          break
        //        case 401:
        //            Message.closeAll()
        //            Message.error('信息登录过期，请重新登录！')
        //            localStorage.setItem("userinfo", "");
        //            localStorage.setItem("role", "");
        //            localStorage.setItem("navIndex", "");
        //             localStorage.setItem("questionList", "");
        //   localStorage.setItem("token", "");

        //            this.$router.push({ name: "login" });
        //          break
        //         case 405:
        //            Message.closeAll()
        //            Message.error('http请求方式有误！')

        //          break
        //         case 500:
        //            Message.closeAll()
        //            Message.error('服务器出了点小差，请稍后再试！')

        //          break
        //         case 501:
        //            Message.closeAll()
        //            Message.error('服务器不支持当前请求所需要的某个功能！')

        //             break
        //         default:
        //            Message.closeAll()
        //            Message.error('信息登录过期，请重新登录！')
        //            localStorage.setItem("userinfo", "");
        //            localStorage.setItem("role", "");
        //            localStorage.setItem("navIndex", "");
        //             localStorage.setItem("questionList", "");
        //   localStorage.setItem("token", "");

        //            this.$router.push({ name: "login" });
        //             break
        //      }
        // } else {
        Message.closeAll()
        Message({
            message: '连接错误',
            type: 'error',
            duration: 5 * 1000
        })
        // return
        // }

        return Promise.reject(error)

    }
)

//封装请求方法
export function get(url, params, headers) {
    // console.log(url)
    const options = {}
    if (params) {
        options.params = params
    }
    if (headers) {
        options.headers = headers
    }
    return service.get(url, options)
}

export function post(url, params, headers) {
    const options = {}
    if (headers) {
        options.headers = headers
    }
    return service.post(url, params, options)
}

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js